import * as _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import * as actions from '../../../../store/modules/actions'
import * as getters from '../../../../store/modules/getters'
import FbVNode from '../../../base/FbVNode.vue'

const IMG_ALIGNMENT = {
  'mx-auto': 'text-center',
  'ml-auto': 'text-right',
  'mr-auto': 'text-left',
}

export default FbVNode.extend({
  props: {
    alt: String,
    width: Number,
    href: String,
  },
  data() {
    return {
      name: 'BrandLogo',
    }
  },
  computed: {
    ...mapGetters({
      src: getters.THEME_BRAND_LOGO,
    }),
    imgWrapperClasses() {
      return {
        [this.stylesheet.classes.spacing]: true,
        [IMG_ALIGNMENT[this.bootstrapAlignment]]: true,
      }
    },
    imgClasses() {
      return {}
    },
    imgStyles() {
      return {
        width: this.isGridBuilder
          ? null
          : this.width
          ? `${this.width}%!important`
          : null,
      }
    },
    altSrc() {
      return this.src || '/img/logo-placeholder.svg'
    },
    styles() {
      return {
        spacing: {
          ...this.spacingStyle,
        },
      }
    },
  },
  methods: {
    ...mapActions({
      setBrandLogo: actions.THEME_SET_BRAND_LOGO,
    }),
    updateSrc(assets) {
      if (_.isArray(assets)) {
        this.setBrandLogo(assets[0])
        return
      }

      if (_.isString(assets)) {
        this.setBrandLogo(assets)
        return
      }

      if (assets && assets.image) {
        this.setBrandLogo(assets.image)
        return
      } else {
        this.setBrandLogo('')
        return
      }
    },
    triggerOpenAssetManager() {
      if (this.isGridBuilder) {
        return
      }
      this.openAssetManager(this.updateSrc)
    },
  },
})
